import './CalendarItem.css';
export var calendarButton = '_1basjc2-3-5-0';
export var currentIndicator = '_1basjc1-3-5-0';
export var headerButton = '_1basjc3-3-5-0';
export var outOfScopeDay = '_1basjc0-3-5-0';